document.addEventListener('DOMContentLoaded', function () {
  if (typeof jQuery !== 'undefined' && jQuery('.reviewTicker').length) {
    jQuery('.reviewTicker').bxSlider({
      minSlides: 1,
      maxSlides: 3,
      moveSlides: 1,
      slideWidth: 0,        // important → fixed width remove
      slideMargin: 80,
      ticker: true,
      speed: 30000,
      // adaptiveHeight: true,
      pager: false,
      controls: false,
    });
  }
  if (typeof jQuery !== 'undefined' && jQuery('.coming-stars-slider').length) {

  // Duplicate slides only once
  if (!jQuery('.coming-stars-slider').hasClass('ticker-cloned')) {
    jQuery('.coming-stars-slider')
      .append(jQuery('.coming-stars-slider').html())
      .addClass('ticker-cloned');
  }

  jQuery('.coming-stars-slider').bxSlider({
    ticker: true,
    tickerHover: false,
    speed: 30000,
    minSlides: 12,
    maxSlides: 12,
    slideWidth: 80,
    slideMargin: 60,
    pager: false,
    controls: false,
    auto: false,
    infiniteLoop: true
  });
}
  //  if (typeof jQuery !== 'undefined' && jQuery('.coming-stars-slider').length) {
  //   jQuery('.coming-stars-slider').bxSlider({ 
  //      ticker: true,
  //   tickerHover: false,
  //   speed: 30000,
  //   minSlides: 12,
  //   maxSlides: 12,
  //   slideWidth: 80,
  //   slideMargin: 60,
  //   pager: false,
  //   controls: false,
  //   auto: false,
  //   infiniteLoop: true
  //   })

  //  }
});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.faq-list, .single-faq-list').forEach(function (faqGroup) {

    const faqItems = faqGroup.querySelectorAll('.faq-item');

    // Open First FAQ of each section
    faqItems.forEach(function (item, index) {
      const answer = item.querySelector('.faq-answer');
      const icon = item.querySelector('.faq-icon');

      if (index === 0) {
        item.classList.add('active');
        answer.style.height = answer.scrollHeight + 'px';

        if (icon) {
          icon.innerHTML = icon.dataset.minus;
        }
      } else {
        item.classList.remove('active');
        answer.style.height = 0;

        if (icon) {
          icon.innerHTML = icon.dataset.plus;
        }
      }
    });

    faqItems.forEach(function (item) {
      const button = item.querySelector('.faq-question');

      button.addEventListener('click', function () {
        const answer = item.querySelector('.faq-answer');
        const icon = item.querySelector('.faq-icon');
        const isActive = item.classList.contains('active');

        // Close FAQs of THIS section only
        faqItems.forEach(function (faq) {
          faq.classList.remove('active');

          const faqAnswer = faq.querySelector('.faq-answer');
          const faqIcon = faq.querySelector('.faq-icon');

          faqAnswer.style.height = 0;

          if (faqIcon) {
            faqIcon.innerHTML = faqIcon.dataset.plus;
          }
        });

        // Open clicked FAQ
        if (!isActive) {
          item.classList.add('active');
          answer.style.height = answer.scrollHeight + 'px';

          if (icon) {
            icon.innerHTML = icon.dataset.minus;
          }
        }
      });
    });

  });

});
  
 // related product slider
document.addEventListener('DOMContentLoaded', function () {

  let slider;

  function initSlider() {

    if (slider) {
      slider.destroySlider();
    }

    let windowWidth = window.innerWidth;
    let minSlides;
    let maxSlides;
    let slideMargin = 20;
    let slideWidth;

    let containerWidth = jQuery('.pdp-related-slider').parent().width();

    // Total products
    let totalProducts = jQuery('.pdp-related-slider > li').length;


    if (windowWidth <= 568) {

      minSlides = maxSlides = 1;
      slideWidth = containerWidth;

      slideMargin = 15;

    } else if (windowWidth <= 768) {

      minSlides = maxSlides = 2;
      slideWidth = (containerWidth - slideMargin) / 2;

      slideMargin = 20;

    } else {

      minSlides = maxSlides = 3;
      slideWidth = (containerWidth - (slideMargin * 2)) / 3;

      slideMargin = 20;

    }

    // --- YAHA BADLAV KIYA HAI (Naya Variable) ---
    // Check karein ki kya desktop screen hai aur exactly 3 products hain
    let isStaticDesktop = (windowWidth > 768 && totalProducts === 3);

    slider = jQuery('.pdp-related-slider').bxSlider({

      pager: false,
      controls: false,

      // Exactly 3 products on desktop = no movement
      infiniteLoop: !isStaticDesktop,

      // --- YAHA BHI BADLAV KIYA HAI (Naye Options) ---
      // Agar 3 products hain desktop par, toh touch aur drag dono band ho jayein
      touchEnabled: !isStaticDesktop,
      oneToOneTouch: !isStaticDesktop,

      minSlides: minSlides,
      maxSlides: maxSlides,

      moveSlides: 1,

      slideWidth: slideWidth,
      slideMargin: slideMargin,

      responsive: true

    });


    // Exactly 3 products on desktop = arrows hide
    // Otherwise arrows show like before
    if (isStaticDesktop) {
      jQuery('.related-prev, .related-next').hide();
    } else {
      jQuery('.related-prev, .related-next').show();
    }

  }

  initSlider();

  jQuery('.related-prev').on('click', function(e){
    e.preventDefault();

    if (slider) {
      slider.goToPrevSlide();
    }

  });

  jQuery('.related-next').on('click', function(e){
    e.preventDefault();

    if (slider) {
      slider.goToNextSlide();
    }

  });

  let timer;

  jQuery(window).on('resize', function(){

    clearTimeout(timer);

    timer = setTimeout(function(){

      initSlider();

    },300);

  });

});
 // end code


const img = document.querySelector('.coming-soon-product');

window.addEventListener('scroll', () => {

  const rect = img.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  let progress = (windowHeight - rect.top) / (windowHeight + rect.height * 0.3);
  progress = Math.max(0, Math.min(progress, 1));

  // Start small (70%) and end normal (100%)
  const scale = 0.7 + progress * 0.4;

  img.style.transform = `scale(${scale})`;

});



// Frontier Banner
const img1 = document.querySelector('.frontier-banner-image');

if (img1) {
  let currentScale = 0.5;
  let targetScale = 0.5;

  function updateScale() {
    const rect = img1.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    let progress = 1 - (rect.top / windowHeight);
    progress = Math.max(0, Math.min(progress, 1));

    targetScale = 0.5 + progress * 0.5;

    // Smaller value = slower/smoother animation
    currentScale += (targetScale - currentScale) * 0.05;

    img1.style.transform = `scale(${currentScale})`;

    requestAnimationFrame(updateScale);
  }

  requestAnimationFrame(updateScale);
}





const bird = document.querySelector(".story-section-side-img");
const section = document.querySelector(".our-story-list");

const observer = new IntersectionObserver((entries) => {

  entries.forEach(entry => {

    if (entry.isIntersecting) {

      bird.style.transform = `
        translateX(-40px)
        translateY(-150px)
        scale(0.8)
      `;

      observer.unobserve(section);
    }

  });

}, {
  threshold: 0.5
});

observer.observe(section);

